import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/default-layout-narrow.js";
import { Box, Text } from 'grommet';
import { LatestProductBlogsUpdates } from "../../components/LatestProductBlogsUpdates";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1>{`Khoj`}</h1>
    <Box round={"small"} background={"visuals-1"} pad={"medium"} mdxType="Box">
    <Text size={"small"} lineHeight={"small"} mdxType="Text">
    Khoj as a publically accessible service has been indefinitely suspended. The code for all the software is up on our Github and linked below. 
    </Text>
    </Box>
    <p>{`Khoj is a service that makes it easy to verify messages you receive on your social media accounts.`}</p>
    <h2>{`Android App and Community UI`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1200px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/732a0186861d0ea8a025263654d2c1b3/07a9c/khoj-app-community-ui.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "71.00000000000001%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsTAAALEwEAmpwYAAACr0lEQVQ4y5VUXU8TQRTtH/MH+AcgaoIJUCDERBJFY3hQI0YTBBWNCYZaBRLhxcRi0tLWEiwUjC9gLba2tJW20N3t9273mx7vDIW0T+okJzP3zuyZM3fOrMMwDBiGCcPsAM8ZsCwL/9scJhFYBNvQYZtEQmCktm2jVqvh+ewspqamMD093YWZmZnuHMVPqHcYRCTk8/idSiNLyGeykImItUQigYmJuwiFNhAIBOD1erG2tga/349wONzGJu+/bJyucbRsAyuLPoyNvcat8Td4cH8JUuGIE8bjcWxubf3bWbNJILZHR6b6peJ72I6sIhYNIpXYQb1U4mvSmUO4Xj3C03vX8W17Ey3KNZtNqKoKXdchCWVk0zmUpSoqxyUo5Qoc7EPvyhxu9FzAaG8PHt8ZR00UOWEymYbngxvul88QCe/APrGhyAo0TYNpmZCOasjGBRQyEnIHEkpiAw61aUEuRvBx/iZ6Lvbi9rUxVIrCeQ2Dn0N8rCgyvyRZlrk6y9QhFqr4tZvHEREy0rJQg8Mie+zvfsfK8irmXrzH8oLnXCEjZJfQarW4KkbE+qaioF6tcILDpID8gchRLZFCXW2ieCyiUFJQ009Qb5pUQ+n8UtjNMhJJkkilwv3JiFVNRUVqIJ+WCCKHXFfg0Giy/DWCqu8T6iE/KkEf6kKxS6EgCEilUsiTvRhyuRw3PVPO/NplbLZjOXMAMfYD0s99iPsx8mGVim4hGo1icvIhlhYX4J6fx8K7t3C7XHC73fD5fPB4PBzr6yEEg0EEyJ/8pRimBZUdg9WIYpaLkP9cROJ0DmLY6cTwkBMjw0MYHRmh8RAuX76EK4SrfX0YovnBgQEM9PefKjTbJJ1gdWo0Gnx8VjdWS+bBMx/qusZzmqq1Y72tsP0z6AR/43Tszk1Y/Df8Ad1y4IvgtJctAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Khoj App and Community UI",
            "title": "Khoj App and Community UI",
            "src": "/static/732a0186861d0ea8a025263654d2c1b3/c1b63/khoj-app-community-ui.png",
            "srcSet": ["/static/732a0186861d0ea8a025263654d2c1b3/5a46d/khoj-app-community-ui.png 300w", "/static/732a0186861d0ea8a025263654d2c1b3/0a47e/khoj-app-community-ui.png 600w", "/static/732a0186861d0ea8a025263654d2c1b3/c1b63/khoj-app-community-ui.png 1200w", "/static/732a0186861d0ea8a025263654d2c1b3/07a9c/khoj-app-community-ui.png 1440w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`{/`}<em parentName="p">{` `}<a parentName="em" {...{
          "href": "https://play.google.com/store/apps/details?id=in.co.tattle.khoj"
        }}>{`Download our app from the Play Store`}</a>{` `}</em>{`/}`}</p>
    <p>{`If you wish to answer queries regarding social media posts from users using our Community UI, please reach out to us at `}<a parentName="p" {...{
        "href": "mailto:admin@tattle.co.in"
      }}>{`admin@tattle.co.in`}</a></p>
    <h2>{`Khoj Web Service`}</h2>
    <p>{`Tattle Khoj is the front end for Tattle's search API, but plugged only to the data scraped from IFCN certified fact checking sites.`}</p>
    <p><img parentName="p" {...{
        "src": "https://tattle-media.s3.amazonaws.com/khoj-demo.gif",
        "alt": "Gif showing Khoj being used"
      }}></img></p>
    <p>{`{/`}<em parentName="p">{` `}{/* [Go to Service](https://services.tattle.co.in/khoj/) */}{` `}</em>{`/}`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/tattle-made/kosh"
      }}>{`Go to Code Repository`}</a></p>
    <LatestProductBlogsUpdates projects={["khoj"]} mdxType="LatestProductBlogsUpdates" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      